import { useMutation } from '@tanstack/react-query';

import { useInvalidateCompaniesList } from '@/entities/company';
import {
  createCompany as createCompanyApi,
  ICompanyResponseDto,
  ICreateCompanyRequestDto,
} from '@/shared/api/companies';

export function useCreateCompany() {
  const invalidateCompanyList = useInvalidateCompaniesList();

  const createCompanyMutation = useMutation({
    mutationFn: (vars: ICreateCompanyRequestDto) => createCompanyApi(vars),
    async onSettled() {
      await invalidateCompanyList();
    },
  });

  const createCompany = async (
    data: ICreateCompanyRequestDto,
    onCreate?: () => void
  ): Promise<ICompanyResponseDto> => {
    return createCompanyMutation.mutateAsync(data, { onSuccess: onCreate });
  };

  return {
    createCompany,
    ...createCompanyMutation,
  };
}
